import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function MasterPackSection() {
  const benefits = ['💬 Charlar más y conectar de verdad', '😄 Crear recuerdos inolvidables', '💖 Fortalecer la confianza', '⏰ Aprovechar el tiempo juntos', '🌈 Recuperar la alegría', '✨ Salir de la rutina', '🧠 Entender más a tus hijos', '🎯 Ahorrar tiempo planificando'];
  return <section className="cv-auto py-16 md:py-24 px-4 sm:px-6 lg:px-8 bg-navy-950" data-id="element-148">
      <div className="max-w-4xl mx-auto" data-id="element-149">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-navy-900 border border-purple-900/50 rounded-3xl p-6 md:p-12 relative overflow-hidden shadow-2xl" data-id="element-150">
          <div className="absolute top-0 right-0 w-64 h-64 bg-purple-600/10 rounded-full blur-3xl pointer-events-none hidden md:block" data-id="element-151" />

          <h2 className="text-2xl md:text-3xl font-bold text-center mb-8 relative z-10" data-id="element-152">
            ¿Qué vas a lograr?
          </h2>

          <div className="grid md:grid-cols-2 gap-4 relative z-10" data-id="element-153">
            {benefits.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.04,
            duration: 0.3
          }} className="flex items-start gap-3 bg-navy-950/50 p-4 rounded-xl border border-navy-800" data-id="element-154">
                <CheckCircle2 className="w-5 h-5 text-purple-400 flex-shrink-0 mt-0.5" data-id="element-155" />
                <span className="text-slate-300" data-id="element-156">{item}</span>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}